import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getV2ProviderPriorAuthorizations: build.query<
      GetV2ProviderPriorAuthorizationsApiResponse,
      GetV2ProviderPriorAuthorizationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/prior-authorizations`,
        params: {
          patient_id: queryArg.patientId,
        },
      }),
    }),
    postV2ProviderPriorAuthorizations: build.mutation<
      PostV2ProviderPriorAuthorizationsApiResponse,
      PostV2ProviderPriorAuthorizationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/prior-authorizations`,
        method: "POST",
        body: queryArg.priorAuthorizationCreateRequest,
      }),
    }),
    getV2ProviderPriorAuthorizationsEncountersByEncounterIdContext: build.query<
      GetV2ProviderPriorAuthorizationsEncountersByEncounterIdContextApiResponse,
      GetV2ProviderPriorAuthorizationsEncountersByEncounterIdContextApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/prior-authorizations/encounters/${queryArg.encounterId}/context`,
      }),
    }),
    getV2ProviderPriorAuthorizationsByAuthorizationId: build.query<
      GetV2ProviderPriorAuthorizationsByAuthorizationIdApiResponse,
      GetV2ProviderPriorAuthorizationsByAuthorizationIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/prior-authorizations/${queryArg.authorizationId}`,
      }),
    }),
    patchV2ProviderPriorAuthorizationsByAuthorizationId: build.mutation<
      PatchV2ProviderPriorAuthorizationsByAuthorizationIdApiResponse,
      PatchV2ProviderPriorAuthorizationsByAuthorizationIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/prior-authorizations/${queryArg.authorizationId}`,
        method: "PATCH",
        body: queryArg.priorAuthorizationUpdateRequest,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetV2ProviderPriorAuthorizationsApiResponse =
  /** status 200 OK */ PriorAuthorizationListResponse;
export type GetV2ProviderPriorAuthorizationsApiArg = {
  patientId: string;
};
export type PostV2ProviderPriorAuthorizationsApiResponse =
  /** status 201 Created */ PriorAuthorizationResponse2;
export type PostV2ProviderPriorAuthorizationsApiArg = {
  priorAuthorizationCreateRequest: PriorAuthorizationCreateRequest;
};
export type GetV2ProviderPriorAuthorizationsEncountersByEncounterIdContextApiResponse =
  /** status 200 OK */ PriorAuthorizationClaimContext;
export type GetV2ProviderPriorAuthorizationsEncountersByEncounterIdContextApiArg =
  {
    encounterId: string;
  };
export type GetV2ProviderPriorAuthorizationsByAuthorizationIdApiResponse =
  /** status 200 OK */ PriorAuthorizationResponse2;
export type GetV2ProviderPriorAuthorizationsByAuthorizationIdApiArg = {
  authorizationId: string;
};
export type PatchV2ProviderPriorAuthorizationsByAuthorizationIdApiResponse =
  /** status 200 OK */ PriorAuthorizationResponse2;
export type PatchV2ProviderPriorAuthorizationsByAuthorizationIdApiArg = {
  authorizationId: string;
  priorAuthorizationUpdateRequest: PriorAuthorizationUpdateRequest;
};
export type PriorAuthorizationResponse = {
  acquisition_channel?: string | null;
  auth_end_date?: string | null;
  auth_number?: string | null;
  auth_start_date: string;
  authorized_quantity: number;
  billed_label: string | null;
  billed_sessions: number | null;
  continues_authorization_id?: string | null;
  course_authorized_quantity: number;
  course_id: string;
  coverage_id?: string | null;
  cpt_codes: string[];
  created_at?: string | null;
  documented_label: string | null;
  documented_sessions: number | null;
  external_ref?: string | null;
  id: string;
  indication?: string | null;
  kind: "authorization" | "benefit_limit";
  notes?: string | null;
  organization_id: string;
  patient_id: string;
  prior_visits_used: number;
  quantity_unit: "visits" | "units" | "days" | "hours";
  source: string;
  status: "active" | "exhausted" | "expired" | "voided" | "denied";
  updated_at?: string | null;
  utilization_supported: boolean;
};
export type PriorAuthorizationListResponse = {
  items: PriorAuthorizationResponse[];
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type PriorAuthorizationResponse2 = {
  acquisition_channel?: string | null;
  auth_end_date?: string | null;
  auth_number?: string | null;
  auth_start_date: string;
  authorized_quantity: number;
  billed_label: string | null;
  billed_sessions: number | null;
  continues_authorization_id?: string | null;
  course_authorized_quantity: number;
  course_id: string;
  coverage_id?: string | null;
  cpt_codes: string[];
  created_at?: string | null;
  documented_label: string | null;
  documented_sessions: number | null;
  external_ref?: string | null;
  id: string;
  indication?: string | null;
  kind: "authorization" | "benefit_limit";
  notes?: string | null;
  organization_id: string;
  patient_id: string;
  prior_visits_used: number;
  quantity_unit: "visits" | "units" | "days" | "hours";
  source: string;
  status: "active" | "exhausted" | "expired" | "voided" | "denied";
  updated_at?: string | null;
  utilization_supported: boolean;
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type PriorAuthorizationCreateRequest = {
  acquisition_channel?: string | null;
  auth_end_date?: string | null;
  auth_number?: string | null;
  auth_start_date: string;
  authorized_quantity: number;
  continues_authorization_id?: string | null;
  coverage_id?: string | null;
  cpt_codes: string[];
  external_ref?: string | null;
  indication?: string | null;
  kind?: "authorization" | "benefit_limit";
  notes?: string | null;
  patient_id: string;
  prior_visits_used?: number;
  quantity_unit?: "visits" | "units" | "days" | "hours";
  source?: string;
  status?: "active" | "exhausted" | "expired" | "voided" | "denied";
};
export type PriorAuthorizationKind = "authorization" | "benefit_limit";
export type QuantityUnit = "visits" | "units" | "days" | "hours";
export type PriorAuthorizationStatus =
  | "active"
  | "exhausted"
  | "expired"
  | "voided"
  | "denied";
export type PriorAuthorizationClaimCourse = {
  auth_end_date: string | null;
  auth_number: string | null;
  auth_start_date: string;
  authorization_id: string;
  billed_label: string | null;
  billed_sessions: number | null;
  course_authorized_quantity: number;
  course_id: string;
  coverage_id: string | null;
  documented_label: string | null;
  documented_sessions: number | null;
  kind: PriorAuthorizationKind;
  quantity_unit: QuantityUnit;
  seed_explanation?: string | null;
  status: PriorAuthorizationStatus;
  utilization_supported: boolean;
};
export type PriorAuthorizationClaimContext = {
  can_rebuild_from_source: boolean;
  claim_snapshot_number: string | null;
  conflicting_course_ids?: string[];
  course?: PriorAuthorizationClaimCourse | null;
  indicator_label?: string | null;
  indicator_state?: "hidden" | "progress" | "attention";
  lookup_state: "none" | "matched" | "conflict" | "unavailable";
  snapshot_state: "empty" | "in_sync" | "preserved" | "mismatch";
  unavailable_reason?: string | null;
};
export type PriorAuthorizationUpdateRequest = {
  acquisition_channel?: string | null;
  auth_end_date?: string | null;
  auth_number?: string | null;
  auth_start_date?: string | null;
  authorized_quantity?: number | null;
  coverage_id?: string | null;
  cpt_codes?: string[] | null;
  external_ref?: string | null;
  indication?: string | null;
  kind?: ("authorization" | "benefit_limit") | null;
  notes?: string | null;
  quantity_unit?: ("visits" | "units" | "days" | "hours") | null;
  source?: string | null;
  status?: ("active" | "exhausted" | "expired" | "voided" | "denied") | null;
};
